
import RatingProps from './mixins/RatingProps';
import { RatingPropertyType, RatingEventType } from './enums';
import RatingItem from './rating-item';
import StyleClassNamesBuilder from '../../../../../styles/helpers/StyleClassNamesBuilder';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';

export default {
  name: 'Rating',
  components: {
    RatingItem,
    Typography,
  },
  mixins: [
    RatingProps,
  ],
  data() {
    return {
      RatingPropertyType,
      TypographyType,
    };
  },
  computed: {
    isDisabled() {
      return this[RatingPropertyType.Disabled];
    },
    ratingName() {
      return this[RatingPropertyType.Name];
    },
    checkedIconValue() {
      return this[RatingPropertyType.CheckedIcon];
    },
    uncheckedIconValue() {
      return this[RatingPropertyType.UncheckedIcon];
    },
    sizeValue() {
      return this[RatingPropertyType.Size];
    },
    color() {
      return this[RatingPropertyType.ColorScheme];
    },
    ratingClassNames() {
      return new StyleClassNamesBuilder('rating')
        .addConditionClassName('disabled', this.isDisabled)
        .build();
    },
  },
  methods: {
    handleChange(value) {
      this.$emit(RatingEventType.Change, value);
    },
    getIsChecked(value) {
      return value <= this[RatingPropertyType.Value];
    },
  },
};
